module.exports = __webpack_public_path__ + "static/media/BP.37fcbc05.png";